import { createSlice } from "@reduxjs/toolkit";

const initialState = { chartData: {}, };

const chartSlice = createSlice({
    name: 'chartfilter',
    initialState,
    reducers: {
        setChartFilteredData: (state, action) => {
            state.chartData = action.payload;
        },
    },
});

export const { setChartFilteredData } = chartSlice.actions;
export default chartSlice.reducer;